import * as React from 'react';
import { RowContainerComponentProps, Textarea, ButtonPrimary } from 'ui';
import { AddDocumentItemOptions } from 'app/infrastructure/ui/form/types';
import styles from './comment-input.scss';

/**
 * Creates CommentInput component. Represents input field for adding comments.
 *
 */

 interface CommentInputTranslations {
  /**
   * The label text for the add button
   */
  textAddItem?: string;
  /**
   * Placeholder text for the input
   */
  placeholder?: string;
 }

export interface CommentInputProps extends RowContainerComponentProps, CommentInputTranslations {

  onAddDocumentItem?: (selectAddedItem?: boolean, options?: AddDocumentItemOptions) => void;
  /**
   * Function that will transform the input text into the final argument passed into onAddDocumentItem callback as argument
   */
  valueFormatter?: (text: string) => any;
  /**
   * Maximum length of characters allowed in the text field. Default is 4000.
   */
  maxLength?: number;
}

export class CommentInput extends React.PureComponent<CommentInputProps, any> {
  public static defaultProps: Partial<CommentInputProps> = {
    maxLength: 4000
  };

  public state: Readonly<any> = {
    input: ''
  };

  private onChange = (value: string) => {
    this.setState({input: value});
  };

  private commentIsEmpty = (): boolean => !(this.state.input && !(this.state.input.match(/^\s+$/)));

  private handleAddComment = () => {

    if (this.props.onAddDocumentItem && !this.commentIsEmpty()) {
      const args = this.props.valueFormatter && this.props.valueFormatter(this.state.input);
      this.props.onAddDocumentItem(false, { initialValues: args } as AddDocumentItemOptions);
      this.setState({input: ''});
    }
  };

  public render() {
    const {
      componentId,
      textAddItem,
      placeholder,
      enabledChildEntityOperations = { add: false },
      maxLength
    } = this.props;

    const userImg = <div className={styles.userIcon}/>;

    const textArea = <Textarea componentId={componentId} className={styles.commentInput}
                               value={this.state.input} onChange={this.onChange} placeholder={placeholder}
                               wait={100} maxLength = {maxLength}/>;

    const addButton = <div className="input-group-btn">
                        <ButtonPrimary disabled={this.commentIsEmpty()} onClick={this.handleAddComment}>
                          {textAddItem}
                        </ButtonPrimary>
                      </div>;

    return (
      <div className={`${styles.commentInputContainer} form-group`}>
        <div className={styles.userIconWrapper}>
          {userImg}
          {textArea}
        </div>
        {enabledChildEntityOperations?.add && addButton}
      </div>
    );
  }
}
